import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@diggens/api-client';
import type { Conversation } from '@diggens/types';

/** The signed-in user's Manager conversations, newest first; the API scopes them to the caller. */
export const CONVERSATIONS_QUERY_KEY = ['chat', 'conversations'] as const;

export function useConversations() {
  return useQuery({
    queryKey: CONVERSATIONS_QUERY_KEY,
    queryFn: () => apiFetch<Conversation[]>('/chat/conversations'),
  });
}

export function useDeleteConversation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (conversationId: string) => apiFetch<{ success: boolean }>(`/chat/conversations/${encodeURIComponent(conversationId)}`, { method: 'DELETE' }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: CONVERSATIONS_QUERY_KEY });
    },
  });
}
